import { WallSconceFlatVariantIcon } from './WallSconceFlatVariantIcon';

/**
 * author: Michael Irigoyen
 * id DEAC0604-6FD1-496C-99E1-74068FC27713
 * name wall-sconce-flat-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wall-sconce-flat-variant.svg
 * tags
 * - Home Automation 
 */
export const PotLightFlatVariantIcon = WallSconceFlatVariantIcon;
export default PotLightFlatVariantIcon